import React, { useContext, useEffect, useState } from "react";
import { FaPlus, FaSearch, FaEdit, FaTrash } from "react-icons/fa";
import axios from "axios";
import AppContext from "../../../context/Appcontext";
import AdminLayout from "../../../layouts/AdminLayout/AdminLayout";
import "../../../assets/css/admin/CreateRoadmap.css";

const CreateRoadmap = () => {
  const { baseUrl, baseUrlForFiles } = useContext(AppContext);

  /*===================================  STATES  ===================================*/
  const [roadmapIdForUpdate, setRoadmapIdForUpdate] = useState(null);
  const [roadmapImage, setRoadmapImage] = useState(null);
  const [imageForEdit, setImageForEdit] = useState("");
  const [title, setTitle] = useState("");
  const [category, setCategory] = useState("");
  const [description, setDescription] = useState("");
  const [duration, setDuration] = useState("");
  const [modules, setModules] = useState("");
  const [students, setStudents] = useState("");
  const [completion, setCompletion] = useState("");
  const [difficulty, setDifficulty] = useState("Beginner");
  const [status, setStatus] = useState("Draft");
  const [roadmaps, setRoadmaps] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    viewAllRoadmaps();
  }, []);

  /*===================================  API CALLS  ===================================*/

  const viewAllRoadmaps = () => {
    axios
      .get(`${baseUrl}/admin/roadmap/viewAllRoadmaps`)
      .then((response) => {
        setRoadmaps(response.data.roadmaps || []);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const createRoadmap = () => {
    const formdata = new FormData();
    formdata.append("image", roadmapImage);
    formdata.append("title", title);
    formdata.append("category", category);
    formdata.append("description", description);
    formdata.append("duration", duration);
    formdata.append("modules", modules);
    formdata.append("students", students);
    formdata.append("completion", completion);
    formdata.append("difficulty", difficulty);
    formdata.append("status", status);

    axios
      .post(`${baseUrl}/admin/roadmap/createRoadmap`, formdata, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => {
        console.log(response);
        alert("Roadmap created!");
        viewAllRoadmaps();
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const updateRoadmap = () => {
    const formdata = new FormData();
    formdata.append("roadmapId", roadmapIdForUpdate);
    formdata.append("image", roadmapImage);
    formdata.append("title", title);
    formdata.append("category", category);
    formdata.append("description", description);
    formdata.append("duration", duration);
    formdata.append("modules", modules);
    formdata.append("students", students);
    formdata.append("completion", completion);
    formdata.append("difficulty", difficulty);
    formdata.append("status", status);

    axios
      .post(`${baseUrl}/admin/roadmap/updateRoadmap`, formdata, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => {
        console.log(response);
        alert("Roadmap updated!");
        viewAllRoadmaps();
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const deleteRoadmap = (id) => {
    if (!window.confirm("Delete this roadmap?")) return;
    axios
      .post(`${baseUrl}/admin/roadmap/deleteRoadmap/${id}`)
      .then((response) => {
        console.log(response);
        viewAllRoadmaps();
      })
      .catch((error) => {
        console.error(error);
      });
  };

  /*===================================  JSX  ===================================*/

  return (
    <AdminLayout>
      <div className="cr-wrapper">
        <div className="container">
          {/* ── PAGE HEADER ── */}
          <div className="cr-page-header">
            <h1 className="cr-page-title">Roadmap Management</h1>
            <p className="cr-page-subtitle">
              Create, update and manage all roadmaps
            </p>
          </div>

          {/* ── FORM CARD ── */}
          <div className="cr-card">
            <div className="cr-card-body">
              <h3 className="cr-form-heading">
                {roadmapIdForUpdate ? "Update Roadmap" : "Add New Roadmap"}
              </h3>

              <div className="row">
                {/* Roadmap Image */}
                <div className="col-md-3">
                  <div className="cr-form-group">
                    <label className="cr-label">Roadmap Image</label>
                    {imageForEdit ? (
                      <img
                        src={`${baseUrlForFiles}/${imageForEdit}`}
                        className="cr-image-preview"
                        alt="preview"
                      />
                    ) : null}
                    <input
                      type="file"
                      accept="image/*"
                      className="cr-file-input"
                      onChange={(e) => setRoadmapImage(e.target.files[0])}
                    />
                  </div>
                </div>

                {/* Title */}
                <div className="col-md-3">
                  <div className="cr-form-group">
                    <label className="cr-label">Title</label>
                    <input
                      type="text"
                      className="cr-input"
                      value={title}
                      onChange={(e) => setTitle(e.target.value)}
                    />
                  </div>
                </div>

                {/* Category */}
                <div className="col-md-3">
                  <div className="cr-form-group">
                    <label className="cr-label">Category</label>
                    <select
                      className="cr-select"
                      value={category}
                      onChange={(e) => setCategory(e.target.value)}
                    >
                      <option value="">Select Category</option>
                      <option>Web Development</option>
                      <option>Mobile Development</option>
                      <option>Data Science</option>
                      <option>UI/UX Design</option>
                      <option>DevOps</option>
                      <option>Cybersecurity</option>
                    </select>
                  </div>
                </div>

                {/* Difficulty */}
                <div className="col-md-3">
                  <div className="cr-form-group">
                    <label className="cr-label">Difficulty</label>
                    <select
                      className="cr-select"
                      value={difficulty}
                      onChange={(e) => setDifficulty(e.target.value)}
                    >
                      <option>Beginner</option>
                      <option>Intermediate</option>
                      <option>Advanced</option>
                    </select>
                  </div>
                </div>

                {/* Duration */}
                <div className="col-md-3">
                  <div className="cr-form-group">
                    <label className="cr-label">Duration</label>
                    <input
                      type="text"
                      className="cr-input"
                      placeholder="e.g. 8 weeks"
                      value={duration}
                      onChange={(e) => setDuration(e.target.value)}
                    />
                  </div>
                </div>

                {/* Modules */}
                <div className="col-md-3">
                  <div className="cr-form-group">
                    <label className="cr-label">Modules</label>
                    <input
                      type="number"
                      className="cr-input"
                      value={modules}
                      onChange={(e) => setModules(e.target.value)}
                    />
                  </div>
                </div>

                {/* Students */}
                <div className="col-md-3">
                  <div className="cr-form-group">
                    <label className="cr-label">Students</label>
                    <input
                      type="number"
                      className="cr-input"
                      value={students}
                      onChange={(e) => setStudents(e.target.value)}
                    />
                  </div>
                </div>

                {/* Completion */}
                <div className="col-md-3">
                  <div className="cr-form-group">
                    <label className="cr-label">Completion (%)</label>
                    <input
                      type="number"
                      className="cr-input"
                      value={completion}
                      onChange={(e) => setCompletion(e.target.value)}
                    />
                  </div>
                </div>

                {/* Status */}
                <div className="col-md-3">
                  <div className="cr-form-group">
                    <label className="cr-label">Status</label>
                    <select
                      className="cr-select"
                      value={status}
                      onChange={(e) => setStatus(e.target.value)}
                    >
                      <option value="Draft">Draft</option>
                      <option value="Published">Published</option>
                      <option value="Pending Review">Pending Review</option>
                    </select>
                  </div>
                </div>

                {/* Description */}
                <div className="col-md-12">
                  <div className="cr-form-group">
                    <label className="cr-label">Description</label>
                    <textarea
                      className="cr-textarea"
                      rows={4}
                      value={description}
                      onChange={(e) => setDescription(e.target.value)}
                    />
                  </div>
                </div>
              </div>

              {/* Buttons */}
              <div className="cr-btn-actions">
                <button
                  className="cr-btn-primary"
                  onClick={() => {
                    if (roadmapIdForUpdate == null) {
                      createRoadmap();
                    } else {
                      updateRoadmap();
                    }
                  }}
                >
                  <FaPlus />
                  {roadmapIdForUpdate == null
                    ? "Add Roadmap"
                    : "Update Roadmap"}
                </button>
                {roadmapIdForUpdate && (
                  <button
                    className="cr-btn-secondary"
                    onClick={() => {
                      setRoadmapIdForUpdate(null);
                      setRoadmapImage(null);
                      setImageForEdit("");
                      setTitle("");
                      setCategory("");
                      setDescription("");
                      setDuration("");
                      setModules("");
                      setStudents("");
                      setCompletion("");
                      setDifficulty("Beginner");
                      setStatus("Draft");
                    }}
                  >
                    Cancel
                  </button>
                )}
              </div>
            </div>
          </div>

          {/* ── TABLE CARD ── */}
          <div className="cr-table-card">
            {/* Table Header */}
            <div className="cr-table-header">
              <h3 className="cr-table-title">All Roadmaps</h3>
              <div className="cr-search-wrapper">
                <span className="cr-search-icon">
                  <FaSearch />
                </span>
                <input
                  type="text"
                  className="cr-search-input"
                  placeholder="Search roadmaps..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
              </div>
            </div>

            {/* Table */}
            <table className="cr-table">
              <thead>
                <tr>
                  <th>Image</th>
                  <th>Title</th>
                  <th>Category</th>
                  <th>Difficulty</th>
                  <th>Duration</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {roadmaps.length > 0 ? (
                  roadmaps
                    .filter((r) =>
                      r.title
                        ?.toLowerCase()
                        .includes(searchQuery.toLowerCase()),
                    )
                    .map((roadmap) => (
                      <tr key={roadmap.id}>
                        <td>
                          {roadmap.image ? (
                            <img
                              src={`${baseUrlForFiles}/${roadmap.image}`}
                              alt="roadmap"
                              className="cr-table-img"
                            />
                          ) : (
                            <span className="cr-no-image">No Image</span>
                          )}
                        </td>
                        <td>{roadmap.title}</td>
                        <td>{roadmap.category || "-"}</td>
                        <td>
                          <span
                            className={`cr-badge cr-badge-${roadmap.difficulty?.toLowerCase() || "beginner"}`}
                          >
                            {roadmap.difficulty || "-"}
                          </span>
                        </td>
                        <td>{roadmap.duration || "-"}</td>
                        <td>
                          <span
                            className={`cr-badge cr-badge-${roadmap.status?.toLowerCase() || "draft"}`}
                          >
                            {roadmap.status || "Draft"}
                          </span>
                        </td>
                        <td>
                          <div className="cr-action-group">
                            <button
                              className="cr-btn-edit"
                              onClick={() => {
                                setRoadmapIdForUpdate(roadmap.id);
                                setTitle(roadmap.title || "");
                                setCategory(roadmap.category || "");
                                setDescription(roadmap.description || "");
                                setDuration(roadmap.duration || "");
                                setModules(roadmap.modules || "");
                                setStudents(roadmap.students || "");
                                setCompletion(roadmap.completion || "");
                                setDifficulty(roadmap.difficulty || "Beginner");
                                setStatus(roadmap.status || "Draft");
                                setImageForEdit(roadmap.image || "");
                                window.scrollTo({ top: 0, behavior: "smooth" });
                              }}
                            >
                              <FaEdit />
                            </button>
                            <button
                              className="cr-btn-delete"
                              onClick={() => deleteRoadmap(roadmap.id)}
                            >
                              <FaTrash />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))
                ) : (
                  <tr>
                    <td colSpan="7">
                      <div className="cr-empty-state">
                        <span className="cr-empty-icon">🗺️</span>
                        <p className="cr-empty-text">No roadmaps found</p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default CreateRoadmap;
